module.exports = __webpack_public_path__ + "static/media/social-media.d6e2a21f.6ad567eb.svg";